export default "__VITE_ASSET__Cln$qydk__ 720w";